var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-overlay',{attrs:{"value":_vm.show}},[_c('ProgressComponent',{attrs:{"size":128,"indeterminate":true,"width":12}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }